
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import CPLoader from '@/components/globals/CPLoader.vue';

@Component({
  components: {
    CPLoader,
  },
})
export default class CPFetchingOverlay extends Vue {

}
